import { Dialog } from '@material-ui/core';
import { FormLabel } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { FormGroup } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import React from 'react';
import 'react-quill/dist/quill.bubble.css'
import './lecture.css'

const singlequestionstyle = {
    margin:'5px'
  }

  const questionstyle = {
    fontWeight: '700'
  }

  const answerblock = {
      width: '100%',
      position: 'relative',

  }

  const answertextstyle = {
    zIndex : '500'
  }

  const balkenstyle = {
      color: 'grey',
      fontSize : '40%',
      position: 'absolute',
      top : '0px',
      left: '0px',
      height: '100%',
  }

export class TestStatistics extends React.Component {
    constructor(props){
        super(props)
        this.state = {}
      }

      componentDidMount (){
        console.log('mount',this.props.id)
        if (this.props.id){
        let s = this.props.socket
        s.emit('get test answer stats',{id:this.props.id},data => {
        this.setState(data)
        console.log(data)
        })}    
    }

      componentDidUpdate (prevProps){

        console.log('update',this.props.id)
        if (this.props.id !== prevProps.id){
        let s = this.props.socket
        s.emit('get test answer stats',{id:this.props.id},data => {
        this.setState(data)
        console.log(data)
        })}
    
    }

    render () {
        const {correctanswers,totaltests,totalusers,totalpassed,testresults,maxanswers} = this.state
        return (
        <div>
            <div>Testanzahl: {totaltests}</div> 
            <div>MA-Anzahl: {totalusers} </div>
            <div>Bestanden: {totalpassed} </div>
            <Paper>

            {testresults && testresults.map((q,i) => 
            <Paper key={i} className="ql-bubble" style={singlequestionstyle}>
            {q.frage && <div className="question ql-editor" style={questionstyle} dangerouslySetInnerHTML={{__html: q.frage}}></div>}
            {q.antworten && q.antworten.map((a,v) => 
                <div style={answerblock}>
                  <div className="answer ql-editor" style={answertextstyle} dangerouslySetInnerHTML={{__html: a.text}}></div>
                  <div style={{...balkenstyle, width: 100*(a.anzahl/maxanswers)+'%',backgroundColor: correctanswers[q.frage].includes(a.text) ? '#0080002e' : '#f4433638'}}>{a.anzahl}</div>
                </div>
                )}
          </Paper>
            )}
        </Paper>
        </div>
    )
    }
}

